module.exports = __webpack_public_path__ + "img/logo-3-light.cf2945a1.png";